import { darken } from "@material-ui/core/styles/colorManipulator";
import { alpha } from "../../utils/muiCompat";
import {
  gradientBgLight,
  gradientBgDark,
  MARGEM_PAGINA,
  LARGURA_RAIL as railWidth,
  LARGURA_SIDEBAR as drawerWidth
} from "../../containers/Templates/appStyles-jss";
import { Theme } from "@material-ui/core";
import iconeMenu from "../../styles/images/menu-lateral/menu.png";
export const ALTURA_CABECALHO = 66;
const PADDING_ICON_BUTTON = 12;

const styles = (theme: Theme) => ({
  appBar: {
    background: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: "none",
    zIndex: theme.zIndex.drawer + 1,
    // o AppBar era transparente e deixava a sidebar aparecer por baixo; agora que e
    // branco, precisa comecar depois dela para nao cobri-la (a sidebar vai ate o topo)
    [theme.breakpoints.up("lg")]: {
      marginLeft: railWidth,
      width: `calc(100% - ${railWidth}px)`
    },
    transition: theme.transitions.create(["width", "margin", "background"], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.leavingScreen
    }),
    "& $menuButton": {
      color: theme.palette.common.white,
      // fechado: sem circulo, mesma cor da sidebar (transparente sobre o navy). Aberto, o
      // appBarShift devolve o circulo azul (primary.main) na borda direita, como na producao.
      backgroundColor: "transparent",
      boxShadow: "none",
      zIndex: 10,
      "&:hover": {
        backgroundColor: alpha(theme.palette.common.white, 0.16)
      }
    },
    "&$left": {
      // o botao e posicionado pelo "left" (centralizado na borda da sidebar);
      // qualquer margem lateral aqui o tira do centro
      "& $menuButton": {
        marginLeft: 0
      },
      "& $headerTitle": {
        right: theme.spacing(2)
      }
    },
    "&$right": {
      "& $menuButton": {
        marginRight: 13
      },
      "& $headerTitle": {
        left: theme.spacing(2)
      },
      "& > div": {
        flexDirection: "row-reverse"
      },
      "& $flex": {
        textAlign: "left"
      }
    }
  },
  attachedbar: {
    position: "relative",
    "& $menuButton": {
      margin: `0 ${theme.spacing(2)}px`
    },
    "& $wrapper": {
      [theme.breakpoints.down("lg")]: {
        border: `1px solid ${theme.palette.divider}`
      }
    }
  },
  floatingBar: {
    position: "fixed"
  },
  toolbar: {
    [theme.breakpoints.up("sm")]: {
      minHeight: ALTURA_CABECALHO
    }
  },
  appMenu: {
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row",
    background: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    [theme.breakpoints.down("md")]: {
      padding: `${theme.spacing() / 2}px 0`
    },
    [theme.breakpoints.up("lg")]: {
      background: alpha(theme.palette.background.paper, 0.8)
    },
    color: theme.palette.text.primary
  },
  flex: {
    flex: 1,
    textAlign: "right"
  },
  flexDefault: {
    flex: 1,
    textAlign: "right"
  },
  left: {},
  right: {},
  appBarShift: {
    transition: theme.transitions.create(["width", "margin", "background"], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    "&$left": {
      [theme.breakpoints.up("lg")]: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        // centralizado sobre a borda direita da sidebar aberta. Abaixo de lg a sidebar e
        // temporaria e some ao fechar: o botao tem de continuar no canto esquerdo.
        "& $menuButton": {
          left: drawerWidth - 20
        }
      }
    },
    "&$right": {
      "& $menuButton": {
        [theme.breakpoints.up("lg")]: {
          marginRight: -20
        }
      },
      [theme.breakpoints.up("lg")]: {
        marginRight: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`
      }
    },
    "& $menuButton": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: theme.shadows[2]
    },
    "& $headerAction": {
      marginLeft: theme.spacing()
    },
    "&$darker": {
      "& $menuButton": {
        [theme.breakpoints.up("lg")]: {
          color: theme.palette.common.white
        }
      }
    }
  },
  // sidebar expandida por hover: a barra desliza junto, mas o hamburguer continua no
  // canto esquerdo, sobre a sidebar, como quando ela esta recolhida
  appBarMenuFixo: {
    "&$left": {
      "& $menuButton": {
        left: (railWidth - 40) / 2,
        backgroundColor: "transparent",
        boxShadow: "none"
      }
    }
  },
  // Fechada, o hamburguer (Fab small, 40px) fica centralizado DENTRO do rail (railWidth),
  // como na producao: left = (largura do rail - largura do botao) / 2. Aberta, o appBarShift
  // reposiciona para a borda direita da sidebar (left = drawerWidth - 20).
  menuButton: {
    position: "fixed",
    top: 16,
    left: (railWidth - 40) / 2,
    zIndex: theme.zIndex.drawer + 2,
    // auto-referencia so para empatar a especificidade das regras "& $menuButton" do
    // appBar/appBarShift, que pintam o circulo azul
    "&$menuButton": {
      [theme.breakpoints.down("md")]: {
        top: (ALTURA_CABECALHO - 40) / 2,
        left: 8,
        backgroundColor: "transparent",
        boxShadow: "none",
        color: theme.palette.primary.main
      },
      [theme.breakpoints.down("xs")]: {
        top: ((theme.mixins.toolbar.minHeight as number) - 40) / 2
      }
    }
  },
  // o png e branco: como mascara ele assume a cor do botao, que muda entre desktop e celular
  iconeMenu: {
    display: "inline-block",
    width: 24,
    height: 24,
    backgroundColor: "currentColor",
    WebkitMaskImage: `url(${iconeMenu})`,
    maskImage: `url(${iconeMenu})`,
    WebkitMaskSize: "contain",
    maskSize: "contain",
    WebkitMaskRepeat: "no-repeat",
    maskRepeat: "no-repeat",
    WebkitMaskPosition: "center",
    maskPosition: "center"
  },
  hide: {
    display: "none"
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    width: 200
  },
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  dark: {},
  light: {},
  wrapper: {
    fontFamily: theme.typography.fontFamily,
    position: "relative",
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(),
    borderRadius: 22,
    display: "inline-block",
    "&:hover": {
      background: alpha(theme.palette.common.white, 0.25)
    },
    "&$light": {
      background: alpha(theme.palette.common.white, 0.2)
    },
    "& $miniInput": {
      width: 70
    }
  },
  searchWrapper: {
    [theme.breakpoints.down("md")]: {
      flex: 1,
      textAlign: "right"
    }
  },
  search: {
    width: theme.spacing(9),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      display: "none"
    }
  },
  miniInput: {
    paddingLeft: 0,
    textIndent: "999999px"
  },
  gradientBg: {},
  solidBg: {},
  darker: {
    backgroundAttachment: "fixed",
    boxShadow: theme.shadows[2],
    "&$gradientBg": {
      backgroundImage: "none"
    },
    "&$solidBg": {
      backgroundColor: theme.palette.type === "dark" ? darken(theme.palette.primary.main, 0.4) : theme.palette.background.paper
    },
    "& $menuButton": {
      [theme.breakpoints.up("lg")]: {
        color: theme.palette.common.white
      }
    }
  },
  fixed: {
    position: "fixed",
    left: 0,
    top: 0,
    [theme.breakpoints.up("lg")]: {
      top: theme.spacing(-8)
    },
    "& nav": {
      padding: "16px 0"
    }
  },
  // alinhada com o titulo da pagina, logo abaixo dela
  saudacaoWrap: {
    display: "flex",
    alignItems: "center",
    paddingLeft: MARGEM_PAGINA,
    minWidth: 0,
    maxWidth: "calc(50% - 100px)",
    overflow: "hidden",
    zIndex: 2,
    // Abaixo de lg a sidebar e temporaria e o botao de menu fixo fica sobre a saudacao
    [theme.breakpoints.down("md")]: {
      paddingLeft: theme.spacing(10)
    }
  },
  userMenuWrap: {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingRight: theme.spacing(3),
    zIndex: 2,
    // o glifo do ultimo icone, e nao a borda do botao, deve cair na margem da pagina
    [theme.breakpoints.up("lg")]: {
      paddingRight: MARGEM_PAGINA - PADDING_ICON_BUTTON
    },
    // "Ajuda" e um link: a regra precisa alcancar <a> alem de <button>
    "& > *": {
      marginLeft: theme.spacing()
    }
  },
  separatorV: {
    borderLeft: `1px solid ${theme.palette.grey[300]}`,
    height: 20,
    margin: "0 10px",
    opacity: 0.4
  },
  notifMenu: {
    "& li": {
      height: "auto",
      "& h3": {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
      }
    }
  },
  badgeMenu: {
    "& span": {
      top: 0,
      right: -30
    }
  },
  textNotif: {
    "& span": {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis"
    }
  },
  notifIcon: {
    "& svg": {
      width: 28,
      height: 28
    },
    "& img": {
      width: 26,
      height: 26
    },
    "&$dark": {
      "& svg": {
        fill: theme.palette.text.primary
      }
    },
    "&$light": {
      "& svg": {
        fill: theme.palette.primary.main
      }
    }
  },
  brand: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 20px 5px",
    height: 64,
    position: "absolute",
    width: "100%",
    fontSize: 16,
    margin: 0,
    fontWeight: 500,
    textDecoration: "none",
    color: theme.palette.text.primary,
    "& img": {
      marginRight: 10,
      width: 30
    }
  },
  mainMenu: {
    backgroundColor: theme.palette.background.paper,
    padding: `${theme.spacing()}px 0`,
    boxShadow: theme.shadows[3],
    position: "relative",
    transition: "padding 0.3s ease",
    "& > div": {
      display: "flex",
      justifyContent: "center"
    }
  },
  headMenu: {
    fontSize: 12,
    padding: `${theme.spacing() / 2}px ${theme.spacing()}px ${theme.spacing() / 2}px ${theme.spacing(2)}px`,
    minHeight: "auto",
    margin: `0 ${theme.spacing() / 2}px`
  },
  opened: {
    color: theme.palette.primary.main,
    boxShadow: `inset 0 0 0 1px ${theme.palette.primary.main}`,
    "& svg": {
      fill: theme.palette.primary.main
    }
  },
  rightIcon: {
    marginLeft: theme.spacing() / 2,
    opacity: 0.3
  },
  selected: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.light,
    "&:hover": {
      background: theme.palette.primary.main
    },
    "& svg": {
      fill: theme.palette.primary.light
    },
    "& $rightIcon": {
      opacity: 0.7
    }
  },
  paperMenu: {
    overflow: "auto",
    maxHeight: 500
  },
  popperClose: {
    pointerEvents: "none",
    zIndex: 2
  },
  title: {
    fontSize: 10,
    textTransform: "uppercase",
    marginTop: theme.spacing(3),
    display: "block",
    color: theme.palette.secondary.main,
    lineHeight: "28px",
    fontWeight: "bold",
    background: theme.palette.background.paper,
    borderRadius: (theme as any).rounded.medium
  },
  dropDownMenu: {
    minWidth: 300,
    maxWidth: "calc(100vw - 24px)",
    marginTop: theme.spacing(1.5),
    position: "relative"
  },
  active: {},
  menuItem: {
    "& span": {
      fontSize: 14
    },
    "&$active": {
      borderLeft: `5px solid ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.type === "dark" ? alpha(theme.palette.secondary.main, 0.24) : theme.palette.secondary.light,
      "& span": {
        color: theme.palette.primary.main
      },
      "&:hover": {
        backgroundColor: theme.palette.type === "dark" ? alpha(theme.palette.secondary.main, 0.24) : theme.palette.secondary.light
      }
    }
  },
  megaMenu: {
    padding: `0 ${theme.spacing(2)}px`,
    "& $title": {
      paddingLeft: theme.spacing(2)
    }
  },
  bigIcon: {
    display: "block",
    marginTop: 40,
    "& svg": {
      width: 100,
      height: 100,
      fill: theme.palette.primary.main,
      margin: "0 auto",
      display: "inherit"
    }
  },
  button: {},
  // A logo e absoluta no centro da Toolbar: a esquerda dela quase nao sobra espaco
  // depois da saudacao, entao a faixa do titulo ocupa o vao a direita da logo e o
  // texto e ancorado no fim dela, limitado a metade da faixa para nunca alcancar a logo.
  headerProperties: {
    position: "relative",
    display: "flex",
    flex: 1,
    minWidth: 0,
    alignItems: "center",
    justifyContent: "flex-end",
    zIndex: 1
  },
  // centraliza a logo em relacao a Toolbar inteira, independente da largura da
  // saudacao (a esquerda) e dos icones (a direita)
  headerLogo: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center",
    pointerEvents: "none" as "none",
    zIndex: 3,
    // centralizada a logo avanca sobre os icones do usuario quando a toolbar encurta;
    // abaixo de sm ela volta ao fluxo e o marginLeft auto do userMenuWrap faz a separacao
    [theme.breakpoints.down("sm")]: {
      position: "static" as "static",
      left: "auto",
      transform: "none",
      marginLeft: theme.spacing(2)
    },
    // no celular o botao de menu e flutuante e fica sobre o inicio da toolbar
    [theme.breakpoints.down("xs")]: {
      marginLeft: theme.spacing(9),
      "& img": {
        width: "120px !important"
      }
    }
  },
  fadeOut: {},
  invert: {},
  headerAction: {
    margin: `0 ${theme.spacing(3)}px`,
    transition: "opacity 0.5s ease",
    "& $button": {
      margin: `0 ${theme.spacing()}px / 2`,
      "& svg": {
        fill: alpha(theme.palette.common.white, 0.87),
        width: 28,
        height: 28
      }
    },
    "&$fadeOut": {
      opacity: 0
    },
    "&$invert": {
      "& $button": {
        "& svg": {
          fill: alpha(theme.palette.text.primary, 0.5)
        }
      }
    }
  },
  show: {},
  headerTitle: {
    transition: "all 0.3s ease",
    fontSize: theme.spacing(3),
    position: "absolute",
    fontWeight: 700,
    maxWidth: "50%",
    whiteSpace: "nowrap" as "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    top: 60,
    color: theme.palette.type === "dark" ? theme.palette.primary.light : theme.palette.primary.dark,
    opacity: 0,
    "&$show": {
      top: theme.spacing(-2),
      opacity: 0.87
    }
  },
  swipeDrawerPaper: {
    width: drawerWidth
  },
  searchHeaderMenu: {
    flex: 1,
    flexDirection: "row-reverse",
    display: "flex",
    alignItems: "center"
  }
});

export default styles;
